export default function createNotification(notificationPropsVar) {
  return (message, open) => {
    notificationPropsVar({ message, open });
  };
}